// angular imports
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

// cc-common imports
import { DxWidgetUtils, IconConstants, MessageBoxComponent, Utils } from 'cc-common';

// devextreme imports
import { DxPopupComponent } from 'devextreme-angular';
import notify from 'devextreme/ui/notify';

// service imports
import { ServerErrorService } from '../../../../_services/shared-services/server-error.service';
import { APPaymentService } from '../../_services/accounts-payable/ap-payment.service';
import { HelperService } from '../../../../_services/shared-services/helper.service';

// model imports
import { StatusMessageResultDto } from '../../../../_models/status-message-result-dto';
import { APPaymentVoidParametersDto } from '../../_models/accounts-payable/ap-payment/ap-payment-void-parameters-dto';

// constants imports
import { MessageInterval } from '../../../../_constants/messages-intervals';

@Component({
    selector: 'app-void-ap-payment',
    templateUrl: './void-ap-payment.component.html',
    styleUrls: ['./void-ap-payment.component.scss']
})
export class VoidAPPaymentComponent implements OnInit {
    @ViewChild('voidPaymentPopup', { static: false }) voidPaymentPopup: DxPopupComponent;
    @ViewChild('voidAPPaymentMessageBox', { static: false }) voidAPPaymentMessageBox: MessageBoxComponent;

    @Input() title: string;
    @Input() visible = false;
    @Input() communityId: number;
    @Input() managementCompanyId: number;
    @Input() paymentId: number;
    @Output() onClose = new EventEmitter<boolean>();

    forceReload = false;
    loadingVisible = false;

    iconCancel = IconConstants.CANCEL;
    iconSave = IconConstants.SAVE;

    voidPaymentParameter: APPaymentVoidParametersDto;
    minVoidDate: Date;

    constructor(
        private readonly apPaymentService: APPaymentService,
        private readonly errorService: ServerErrorService,
        private readonly helperService: HelperService
    ) {}

    ngOnInit() {
        this.configureVoidPayment();
    }

    onShown(): void {
        DxWidgetUtils.instantRepaint(this.voidPaymentPopup);
    }

    onHidden(): void {
        this.closeVoidPayment();
    }

    onCancelClick(): void {
        this.closeVoidPayment();
    }

    onSaveClick(): void {
        if (Utils.notNullOrEmpty(this.voidPaymentParameter.voidDescription)) {
            this.doVoidPayment();
        } else {
            this.voidAPPaymentMessageBox.showErrorMessage('Error', 'Description cannot be empty');
        }
    }

    private configureVoidPayment(): void {
        this.voidPaymentParameter = new APPaymentVoidParametersDto();
        this.voidPaymentParameter.voidDate = new Date();
        this.voidPaymentParameter.communityId = this.communityId;
        this.voidPaymentParameter.managementCompanyId = this.managementCompanyId;
        this.voidPaymentParameter.paymentId = this.paymentId;
        this.voidPaymentParameter.voidDescription = '';
        this.populateMinVoidDate();
    }

    private populateMinVoidDate(): void {
        this.apPaymentService.getMinVoidDate(this.paymentId).subscribe(
            (result) => {
                this.minVoidDate = result.minVoidDate;
            },
            (error) => {
                this.errorService.displayError(error);
            }
        );
    }

    private doVoidPayment(): void {
        this.loadingVisible = true;
        this.apPaymentService.voidPayment(this.voidPaymentParameter).subscribe(
            (result: StatusMessageResultDto) => {
                if (Utils.isTrue(result.isSuccessMessage)) {
                    this.forceReload = true;
                    notify(result.message, 'Success', MessageInterval.successMsgInterval);
                    this.closeVoidPayment();
                } else {
                    const dialog = this.helperService.getOkDialog('Error', result.message, 'OK');
                    dialog.show();
                }
                this.loadingVisible = false;
            },
            (error) => {
                this.errorService.displayError(error);
                this.loadingVisible = false;
            }
        );
    }

    private closeVoidPayment(): void {
        this.visible = false;
        this.onClose.emit(this.forceReload);
    }
}
